module.exports = __webpack_public_path__ + "img/max.9f21c314.svg";